import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { staticColors } from '../../../const/colors/staticColors';
import { sizes } from '../../../const/sizes';
import { useTestIdAttribute } from '../../../hooks/useTestIdAttribute';
import { NavigationVertical } from '../../navigation/NavigationVertical/NavigationVertical';
import { FlexContainer } from '../FlexContainer';
import { SidebarAccountSection, } from './SidebarAccountSection';
import { SidebarHeader } from './SidebarHeader';
import { SidebarToggleButton } from './SidebarToggleButton';
const StyledSidebar = styled('aside', ({ $backgroundColor, $borderRight }) => ({
    backgroundColor: $backgroundColor ?? staticColors.cardWhiteBackground,
    borderRight: $borderRight ??
        `${sizes.divider.thickness} solid ${staticColors.divider}`,
    boxSizing: 'border-box',
    minHeight: 0,
    overflow: 'hidden',
}));
const StyledSidebarContent = styled('div', ({ $padding }) => ({
    flex: '1 0 0',
    minHeight: 0,
    padding: $padding,
}));
export const Sidebar = ({ isCollapsed, onToggleCollapsed, logo, expandLabel, collapseLabel, menuItems, ItemWrapper, accountSection, contentPadding, contentGap = '0', backgroundColor, borderRight, testId, }) => {
    const testIdAttribute = useTestIdAttribute(testId);
    const header = (_jsx(SidebarHeader, { isCollapsed: isCollapsed, logo: logo, toggle: _jsx(SidebarToggleButton, { isCollapsed: isCollapsed, expandLabel: expandLabel, collapseLabel: collapseLabel, onToggleCollapsed: onToggleCollapsed }) }));
    const navigation = (_jsx(NavigationVertical, { items: menuItems, ItemWrapper: ItemWrapper, collapsed: isCollapsed }));
    const maybeAccountSection = accountSection && (_jsx(SidebarAccountSection, { ...accountSection, isCollapsed: isCollapsed }));
    return (_jsx(StyledSidebar, { ...testIdAttribute, $backgroundColor: backgroundColor, $borderRight: borderRight, children: _jsxs(FlexContainer, { direction: 'column', horizontalAlign: 'none', grow: 1, basis: 0, shrink: 0, alignSelf: 'stretch', fullHeight: true, children: [_jsx(StyledSidebarContent, { $padding: contentPadding, children: _jsxs(FlexContainer, { direction: 'column', gap: contentGap, horizontalAlign: 'none', verticalAlign: 'top', children: [header, navigation] }) }), maybeAccountSection] }) }));
};
